// extracted by mini-css-extract-plugin
module.exports = {"PurchaseFailed":"PurchaseFailed_PurchaseFailed__29zVm","mainArea":"PurchaseFailed_mainArea__2S7eP","btnBack":"PurchaseFailed_btnBack__1thFH"};